import React, { useEffect } from "react";
import Header from "../components/Layout/Header";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";

const PrivacyPolicyPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <Header />
      <PrivacyPolicy />
    </>
  );
};

export default PrivacyPolicyPage;
